<template>
  <div class="home-page">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-section">
      <div class="container mx-auto px-4 py-4">
        <nav class="flex" aria-label="Breadcrumb">
          <ol class="inline-flex items-center space-x-1 md:space-x-3">
            <li class="inline-flex items-center">
              <a href="/" class="inline-flex items-center text-sm font-medium text-gray-400 hover:text-white">
                <svg class="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"></path>
                </svg>
                Home
              </a>
            </li>
          </ol>
        </nav>
      </div>
    </div>
    
    <!-- 英雄区域 -->
    <div class="hero-section">
      <div class="container mx-auto px-4 py-16 lg:py-24">
        <div class="text-center">
          <h1 class="text-5xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            CyberGame
            <span class="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-600">Hub</span>
          </h1>
          <p class="text-xl lg:text-2xl text-gray-300 mb-8 max-w-3xl mx-auto leading-relaxed">
            Discover the future of PC gaming with our comprehensive platform featuring over 500+ carefully curated games across 15+ genres. Experience instant browser-based gaming with no downloads required, connect with a global community of 2.5M+ active players, and enjoy premium gaming content completely free.
          </p>
          <div class="flex flex-col sm:flex-row gap-4 justify-center">
            <router-link
              to="/games"
              class="bg-blue-600 hover:bg-blue-700 text-white py-4 px-8 rounded-lg font-semibold text-lg transition-colors duration-200 flex items-center justify-center"
            >
              <svg class="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.828 14.828a4 4 0 01-5.656 0M9 10h1m4 0h1m-6 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
              Start Gaming
            </router-link>
            <router-link
              to="/about"
              class="bg-gray-700 hover:bg-gray-600 text-white py-4 px-8 rounded-lg font-semibold text-lg transition-colors duration-200"
            >
              Learn More
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <!-- 特色功能 -->
    <div class="features-section">
      <div class="container mx-auto px-4 py-16">
        <h2 class="text-3xl lg:text-4xl font-bold text-white text-center mb-12">Why Choose CyberGame Hub?</h2>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div class="feature-card bg-gray-800 rounded-lg p-6 text-center">
            <div class="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
              </svg>
            </div>
            <h3 class="text-xl font-semibold text-white mb-3">Instant Gaming</h3>
            <p class="text-gray-400">No downloads, no installations, enjoy games directly in your browser</p>
          </div>
          
          <div class="feature-card bg-gray-800 rounded-lg p-6 text-center">
            <div class="w-16 h-16 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
              </svg>
            </div>
            <h3 class="text-xl font-semibold text-white mb-3">Active Community</h3>
            <p class="text-gray-400">Join our gaming community and share experiences with other players</p>
          </div>
          
          <div class="feature-card bg-gray-800 rounded-lg p-6 text-center">
            <div class="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
            </div>
            <h3 class="text-xl font-semibold text-white mb-3">Free Experience</h3>
            <p class="text-gray-400">All games are completely free, enjoy full content without any payment</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 热门游戏 -->
    <div class="popular-games-section">
      <div class="container mx-auto px-4 py-16">
        <div class="flex items-center justify-between mb-8">
          <h2 class="text-3xl lg:text-4xl font-bold text-white">Popular Games</h2>
          <router-link
            to="/games"
            class="text-blue-400 hover:text-blue-300 font-semibold flex items-center"
          >
            View All
            <svg class="w-5 h-5 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
            </svg>
          </router-link>
        </div>
        
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          <div
            v-for="game in popularGames"
            :key="game.name"
            class="game-card bg-gray-800 rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 hover:transform hover:scale-105"
            @click="viewGame(game)"
          >
            <div class="game-image relative">
              <img
                :src="game.thumb6 || game.thumb5 || game.thumb4"
                :alt="game.name"
                class="w-full h-48 object-cover"
                @error="handleImageError"
              />
              <div class="absolute inset-0 bg-black bg-opacity-0 hover:bg-opacity-20 transition-all duration-300"></div>
              <div class="absolute top-2 left-2">
                <span class="px-2 py-1 bg-blue-600 text-white text-xs rounded-full">
                  {{ game.category }}
                </span>
              </div>
            </div>
            
            <div class="p-4">
              <h3 class="text-lg font-semibold text-white mb-2 line-clamp-2">{{ game.name }}</h3>
              <p class="text-gray-400 text-sm mb-3 line-clamp-2">{{ game.description }}</p>
              
              <div class="text-gray-500 text-xs mb-3">
                Released: {{ formatDate(game.create_date) }}
              </div>
              
              <button
                class="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-lg transition-colors duration-200"
                @click.stop="playGame(game)"
              >
                Play Now
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 游戏指南和教程 -->
    <div class="guides-section">
      <div class="container mx-auto px-4 py-16">
        <h2 class="text-3xl lg:text-4xl font-bold text-white text-center mb-12">Gaming Guides & Tips</h2>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div class="guide-card bg-gray-800 rounded-lg p-6">
            <div class="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"></path>
              </svg>
            </div>
            <h3 class="text-xl font-semibold text-white mb-3 text-center">Beginner's Guide to Browser Gaming</h3>
            <p class="text-gray-400 text-center mb-4">Learn the basics of browser-based gaming, system requirements, and how to optimize your experience for the best performance.</p>
            <div class="text-center">
              <button class="bg-green-600 hover:bg-green-700 text-white py-2 px-4 rounded-lg transition-colors duration-200">
                Read Guide
              </button>
            </div>
          </div>
          
          <div class="guide-card bg-gray-800 rounded-lg p-6">
            <div class="w-16 h-16 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z"></path>
              </svg>
            </div>
            <h3 class="text-xl font-semibold text-white mb-3 text-center">Top Gaming Strategies</h3>
            <p class="text-gray-400 text-center mb-4">Master different game genres with our comprehensive strategy guides. From puzzle games to action adventures, we've got you covered.</p>
            <div class="text-center">
              <button class="bg-purple-600 hover:bg-purple-700 text-white py-2 px-4 rounded-lg transition-colors duration-200">
                View Strategies
              </button>
            </div>
          </div>
          
          <div class="guide-card bg-gray-800 rounded-lg p-6">
            <div class="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg class="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"></path>
              </svg>
            </div>
            <h3 class="text-xl font-semibold text-white mb-3 text-center">Game Reviews & Ratings</h3>
            <p class="text-gray-400 text-center mb-4">Read detailed reviews and ratings from our gaming community. Make informed decisions about which games to play next.</p>
            <div class="text-center">
              <button class="bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-lg transition-colors duration-200">
                Browse Reviews
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 社区特色 -->
    <div class="community-section">
      <div class="container mx-auto px-4 py-16">
        <div class="text-center mb-12">
          <h2 class="text-3xl lg:text-4xl font-bold text-white mb-6">Join Our Gaming Community</h2>
          <p class="text-xl text-gray-300 max-w-3xl mx-auto">
            Connect with fellow gamers, share achievements, participate in tournaments, and discover new gaming experiences together.
          </p>
        </div>
        
        <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div class="community-card bg-gray-800 rounded-lg p-8">
            <h3 class="text-2xl font-semibold text-white mb-4">Weekly Tournaments</h3>
            <p class="text-gray-400 mb-6">
              Participate in weekly gaming tournaments across different genres. Compete with players worldwide and win exciting prizes. New tournaments start every Monday!
            </p>
            <ul class="text-gray-300 space-y-2 mb-6">
              <li class="flex items-center">
                <svg class="w-4 h-4 text-green-400 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                </svg>
                Free to participate
              </li>
              <li class="flex items-center">
                <svg class="w-4 h-4 text-green-400 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                </svg>
                Multiple skill levels
              </li>
              <li class="flex items-center">
                <svg class="w-4 h-4 text-green-400 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                </svg>
                Prizes and achievements
              </li>
            </ul>
            <button class="bg-green-600 hover:bg-green-700 text-white py-3 px-6 rounded-lg transition-colors duration-200">
              Join Tournament
            </button>
          </div>
          
          <div class="community-card bg-gray-800 rounded-lg p-8">
            <h3 class="text-2xl font-semibold text-white mb-4">Gaming Forums</h3>
            <p class="text-gray-400 mb-6">
              Engage in discussions about your favorite games, share tips and tricks, get help from experienced players, and stay updated with the latest gaming news.
            </p>
            <ul class="text-gray-300 space-y-2 mb-6">
              <li class="flex items-center">
                <svg class="w-4 h-4 text-blue-400 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                </svg>
                Active community of 2.5M+ gamers
              </li>
              <li class="flex items-center">
                <svg class="w-4 h-4 text-blue-400 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                </svg>
                Expert moderators and guides
              </li>
              <li class="flex items-center">
                <svg class="w-4 h-4 text-blue-400 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                </svg>
                24/7 community support
              </li>
            </ul>
            <button class="bg-blue-600 hover:bg-blue-700 text-white py-3 px-6 rounded-lg transition-colors duration-200">
              Visit Forums
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 统计数据 -->
    <div class="stats-section">
      <div class="container mx-auto px-4 py-16">
        <div class="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
          <div class="stat-item">
            <div class="text-4xl lg:text-5xl font-bold text-blue-400 mb-2">{{ stats.games }}</div>
            <div class="text-gray-300 text-lg">Games</div>
          </div>
          <div class="stat-item">
            <div class="text-4xl lg:text-5xl font-bold text-purple-400 mb-2">{{ stats.categories }}</div>
            <div class="text-gray-300 text-lg">Categories</div>
          </div>
          <div class="stat-item">
            <div class="text-4xl lg:text-5xl font-bold text-green-400 mb-2">{{ stats.players }}</div>
            <div class="text-gray-300 text-lg">Active Players</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 行动号召 -->
    <div class="cta-section">
      <div class="container mx-auto px-4 py-16 text-center">
        <h2 class="text-3xl lg:text-4xl font-bold text-white mb-6">Ready to Start Your Gaming Journey?</h2>
        <p class="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
          Join CyberGame Hub now and experience unprecedented gaming fun
        </p>
        <router-link
          to="/games"
          class="bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white py-4 px-8 rounded-lg font-semibold text-lg transition-all duration-200 inline-flex items-center"
        >
          <svg class="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.828 14.828a4 4 0 01-5.656 0M9 10h1m4 0h1m-6 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          Start Gaming Now
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import gameService from '@/services/gameService'

export default {
  name: 'Home',
  setup() {
    const router = useRouter()
    const popularGames = ref([])
    const stats = ref({
      games: 0,
      categories: 0,
      players: '10K+'
    })

    // 格式化日期
    const formatDate = (dateString) => {
      const date = new Date(dateString)
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      })
    }

    // 加载热门游戏
    const loadPopularGames = () => {
      try {
        const games = gameService.getPopularGames()
        popularGames.value = games || []
      } catch (error) {
        console.error('Failed to load popular games:', error)
        popularGames.value = []
      }
    }

    // 加载统计数据
    const loadStats = () => {
      try {
        const allGames = gameService.getAllGames()
        const categories = gameService.getGameCategories()
        
        stats.value = {
          games: allGames ? allGames.length : 0,
          categories: categories ? categories.length : 0,
          players: '10K+'
        }
      } catch (error) {
        console.error('Failed to load stats:', error)
        stats.value = {
          games: 0,
          categories: 0,
          players: '10K+'
        }
      }
    }

    // 查看游戏详情
    const viewGame = (game) => {
      router.push(`/game/${encodeURIComponent(game.name)}`)
    }

    // 开始游戏
    const playGame = (game) => {
      router.push(`/game/${encodeURIComponent(game.name)}`)
    }

    // 处理图片错误
    const handleImageError = (event) => {
      event.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAwIiBoZWlnaHQ9IjIwMCIgdmlld0JveD0iMCAwIDMwMCAyMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIzMDAiIGhlaWdodD0iMjAwIiBmaWxsPSIjMTAxMDEwIi8+Cjx0ZXh0IHg9IjE1MCIgeT0iMTAwIiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iMTYiIGZpbGw9IiM2NjY2NjYiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGR5PSIuM2VtIj5HYW1lIEltYWdlPC90ZXh0Pgo8L3N2Zz4K'
    }

    onMounted(() => {
      loadPopularGames()
      loadStats()
    })

    return {
      popularGames,
      stats,
      formatDate,
      viewGame,
      playGame,
      handleImageError
    }
  }
}
</script>

<style scoped>
.home-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
}

.hero-section {
  background: linear-gradient(135deg, rgba(26, 26, 46, 0.9) 0%, rgba(22, 33, 62, 0.9) 100%);
  backdrop-filter: blur(10px);
}

.feature-card {
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}

.feature-card:hover {
  border-color: rgba(59, 130, 246, 0.5);
  transform: translateY(-5px);
}

.game-card {
  cursor: pointer;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.game-card:hover {
  border-color: rgba(59, 130, 246, 0.5);
}

.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.stats-section {
  background: linear-gradient(135deg, rgba(26, 26, 46, 0.8) 0%, rgba(22, 33, 62, 0.8) 100%);
  backdrop-filter: blur(10px);
}

.cta-section {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.1) 0%, rgba(147, 51, 234, 0.1) 100%);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

/* 响应式设计 */
@media (max-width: 640px) {
  .hero-section h1 {
    font-size: 3rem;
  }
}
</style> 